import { useEffect, useState } from "react";

const breakpoints = {
  sm: 480,
  md: 768,
  lg: 1024,
  xl: 1280,
};

export function useResponsive() {
  const [mounted, setMounted] = useState(false);
  const [width, setWidth] = useState<number>(0);

  useEffect(() => {
    setMounted(true);
    setWidth(window.innerWidth);

    const handleResize = () => {
      setWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // ✅ Tránh hydration mismatch
  if (!mounted) {
    return {
      isMobile: false,
      isMobileLg: false,
      isTablet: false,
      isLaptop: false,
      isDesktop: true, // default an toàn cho SSR
    };
  }

  const isMobile = width < breakpoints.md;
  const isMobileSm = width < breakpoints.sm;
  const isMobileLg = width >= breakpoints.sm && width < breakpoints.md;
  const isTablet = width >= breakpoints.md && width < breakpoints.lg;
  const isLaptop = width >= breakpoints.lg && width < breakpoints.xl;
  const isDesktop = width >= breakpoints.lg;

  return {
    isMobile,
    isMobileSm,
    isMobileLg,
    isTablet,
    isLaptop,
    isDesktop,
    width, // bonus nếu cần debug
  };
}
